import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useFormikContext } from "formik";
import React from "react";

import FormField from "@/components/atoms/FormField";
import { MDButton } from "@/components/atoms/MDButton";
import { OrderFormData } from "@/components/screens/OrderFormPage/types";
import { OrderDataTabMessages } from "@/messages/order-form-page/order-data-tab.messages";

type Props = {
  isVisible: boolean;
  handleClose: () => void;
  messages: OrderDataTabMessages;
  disabled: boolean;
};

export default function InvoicedDialog({ isVisible, handleClose, messages, disabled }: Props) {
  const { values, errors, handleChange, setFieldValue } = useFormikContext<OrderFormData>();

  const handleCancel = () => {
    // Restaurar os valores do form com os valores originais do pedido
    setFieldValue("invoiceKey", values.invoiceKey);
    setFieldValue("invoiceNumber", values.invoiceNumber);
    setFieldValue("invoiceSeries", values.invoiceSeries);
    setFieldValue("invoiceXml", values.invoiceXml);

    handleClose();
  };

  return (
    <Dialog open={isVisible} onClose={handleClose}>
      <DialogTitle>{messages.invoiceDialogTitle}</DialogTitle>

      <DialogContent>
        <Grid container spacing={3}>
          <Grid size={{ xs: 12, md: 6 }}>
            <FormField
              variant="standard"
              name="invoiceKey"
              label={messages.invoiceKeyLabel}
              value={values.invoiceKey}
              onChange={handleChange}
              fullWidth
              error={!!errors.invoiceKey}
              disabled={disabled}
            />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <FormField
              variant="standard"
              name="invoiceNumber"
              label={messages.invoiceNumberLabel}
              value={values.invoiceNumber}
              onChange={handleChange}
              fullWidth
              error={!!errors.invoiceNumber}
              disabled={disabled}
            />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <FormField
              variant="standard"
              name="invoiceSeries"
              label={messages.invoiceSeriesLabel}
              value={values.invoiceSeries}
              onChange={handleChange}
              fullWidth
              error={!!errors.invoiceSeries}
              disabled={disabled}
            />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <FormField
              variant="standard"
              name="invoiceXml"
              label={messages.invoiceXmlLabel}
              value={values.invoiceXml}
              onChange={handleChange}
              fullWidth
              error={!!errors.invoiceXml}
              disabled={disabled}
            />
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <MDButton variant="gradient" color="light" onClick={handleCancel}>
          {messages.cancelButton}
        </MDButton>
        <MDButton variant="gradient" color="dark" disabled={disabled} onClick={handleClose}>
          {messages.updateButton}
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}
